export class Hamburger {

    public static SELECTOR_MENU: string = ".nav-mobile--open";
    public static SELECTOR_MENU_CLOSE: string = ".nav-mobile--close";
    public static EVENT_CLICK: string = "click";
    public static CLASSNAME_ACTIVE: string = "nav-hamburger-active";
    public static HASHFRAGMENT_ACTIVE: string = "nav-hamburger-active=1";

    public static get hashFragmentActive(): boolean {
        return window.location.hash.indexOf(this.HASHFRAGMENT_ACTIVE) !== -1;
    }

    /**
     * Auto-instantiates Hamburger menu
     *
     * Also auto-activates the Hamburger menu if a hash fragment exists.
     *
     * @returns {Hamburger | void}
     */
    public static init() {
        const menuOpenElement = document.querySelector(this.SELECTOR_MENU);
        const menuCloseElement = document.querySelector(this.SELECTOR_MENU_CLOSE);
        let hamburger: Hamburger | void;

        if (menuOpenElement != null && menuCloseElement != null) {
            hamburger = new this(menuOpenElement, menuCloseElement);
        }

        // if URL contains `#nav-hamburger-active=1` then activate the menu (for testing purposes)
        if (hamburger != null && this.hashFragmentActive) {
            hamburger.toggleActive();
        }

        return hamburger;
    }

    /**
     * Tracks if the hamburger menu is active
     * @type {boolean}
     */
    private isActive: boolean = false;

    /**
     * Constructs new Hamburger controller
     * @param {Element} menuOpenElement
     * @param {Element} menuCloseElement
     */
    constructor(readonly menuOpenElement: Element,
                readonly menuCloseElement: Element) {
        this.init();
    }

    /**
     * Activates the hamburger menu if active and vice versa
     */
    public toggleActive() {
        if (this.isActive === true) {
            document.body.classList.remove(Hamburger.CLASSNAME_ACTIVE);
        } else {
            document.body.classList.add(Hamburger.CLASSNAME_ACTIVE);
        }

        this.isActive = !this.isActive;
    }

    /**
     * Click handler for the hamburger menu icon
     * @param {MouseEvent} event
     */
    private onMenuClickCallback(event: MouseEvent) {
        event.preventDefault();
        this.toggleActive();
    }

    private onMenuCloseClickCallback(event: MouseEvent) {
        event.preventDefault();
        this.toggleActive();
    }

    /**
     * Creates event handlers for menu and close button
     * @todo add handler for close button (also add actual close button)
     */
    private registerEventHandlers() {
        this.menuOpenElement.addEventListener(Hamburger.EVENT_CLICK, this.onMenuClickCallback.bind(this));
        this.menuCloseElement.addEventListener(Hamburger.EVENT_CLICK, this.onMenuCloseClickCallback.bind(this));
    }

    /**
     * Initializes hamburger menu
     */
    private init() {
        this.registerEventHandlers();
    }
}



// WEBPACK FOOTER //
// ./components/hamburger/hamburger.ts